export default "__VITE_ASSET__DpwzGDTz__"